import styled, { css } from 'styled-components'

export const EventInfoWrapperUi = styled.div<{ titlesColor?: string }>`
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  flex: 1;
  width: 100%;

  ${p =>
    p.color &&
    css`
      & p {
        color: ${p.color};
        font-size: 14px;
      }
    `}

  ${p =>
    p.titlesColor &&
    css`
      & span {
        color: ${p.titlesColor};
        font-size: 16px;
      }
    `}
`
